"use client";

import { AnimatePresence, motion } from "framer-motion";
import { NewsPageQueryResult } from "@/sanity.types";
import NewsCard from "../../utils/news-card/NewsCard";

type NewsDisplayProps = {
	news: NonNullable<NewsPageQueryResult>["orderOfNewsList"];
};

export default function NewsDisplay({ news }: NewsDisplayProps) {
	return (
		<motion.div
			className="grid grid-cols-2 gap-x-5 gap-y-16 sm:grid-cols-6 md:grid-cols-9"
			initial="hidden"
			animate="visible"
			variants={{
				hidden: {},
				visible: {
					transition: {
						staggerChildren: 0.1,
					},
				},
			}}
		>
			<AnimatePresence mode="popLayout">
				{news.map((newsItem, index) => (
					<NewsCard key={newsItem._id} news={newsItem} animationDelay={index * 0.05} />
				))}
			</AnimatePresence>
		</motion.div>
	);
}
